/**
 * Pricing and contact, kept in one component.
 *
 * The product deliberately has no checkout: access is sold by the week in
 * crypto and arranged in a Discord DM. This block is the single place the
 * offer is stated, so the sign-in, request and expired screens cannot drift
 * apart or accidentally advertise a payment flow that does not exist.
 */

import { useState } from 'react';
import { Check, Copy, MessageCircle } from 'lucide-react';

function DiscordTag({ value }: { value: string }): JSX.Element {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1600);
    } catch {
      // Clipboard access can be denied; the username remains selectable text.
    }
  };

  return (
    <button
      type="button"
      className={`discord-tag${copied ? ' copied' : ''}`}
      onClick={() => void copy()}
      title={copied ? 'Copied' : `Copy ${value}`}
    >
      <MessageCircle size={11} />
      {value}
      {copied ? <Check size={11} /> : <Copy size={11} />}
    </button>
  );
}

export function PricingNote(): JSX.Element {
  return (
    <div className="auth-offer">
      <div className="auth-offer-price">
        <strong>$15</strong>
        <span>per week</span>
      </div>
      <div className="auth-offer-copy">
        <span className="auth-offer-kicker">Crypto only · no payments on this site</span>
        <span className="auth-offer-contact">
          <span>DM on Discord</span>
          <span className="auth-offer-handles">
            <DiscordTag value="esoxiii" />
            <span className="auth-offer-or">or</span>
            <DiscordTag value="esoxiii_11638" />
          </span>
        </span>
      </div>
    </div>
  );
}
